import { Loading } from "@doist/reactist";
import { Suspense } from "react";

function SuspenseLoader({ children }) {
    return (<Suspense fallback={<div style={{position: 'absolute'}}>
        <Loading size="small" />
    </div>}>{children}</Suspense>);
};

export default SuspenseLoader;